import { FilesRootLayout } from '../../_components/_layouts/FilesRootLayout';
import { FileGrid } from '../../_components/explorer/FileGrid';

export const SharedFilesView = () => (
  <FilesRootLayout className="@SharedFilesView">
    <div className="p-6">
      <h1 className="mb-6 text-2xl font-semibold">Shared with me</h1>
      <FileGrid viewMode="shared" />
    </div>
  </FilesRootLayout>
);
